import axios from 'axios';

declare global {
  interface Window {
    RUNTIME_CONFIG: {
      BACKEND_URL: string;
    };
  }
}

const createAxiosInstance = () => {
  // const serviceToken:string = localStorage.getItem('serviceToken');

  const instance = axios.create({
    // baseURL: 'http://localhost:9999/client/api/v1',
    // baseURL: 'http://13.232.23.62/client/api/v1',
    baseURL: window.RUNTIME_CONFIG?.BACKEND_URL,
    headers: {
      'Access-Control-Allow-Origin': '*'
    },
  });

  // Interceptor for modifying requests
  instance.interceptors.request.use(
    (config) => {
      const idToken = localStorage.getItem('token');
      if (idToken) {
        if (config.headers) {
          config.headers.Authorization = `Bearer ${idToken}`;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Interceptor for handling response errors
  instance.interceptors.response.use(
    (response) => response,
    (error) =>
      Promise.reject({
        status: error?.response?.status,
        open: true,
        message:
          // error?.response?.data?.errors[0]?.errorMessage || 'Something Wrong',
          error?.response?.data?.errors ??
          'Something Wrong',
        transition: 'Fade',
        variant: 'alert',
        alert: {
          color: 'error',
        },
      })
  );

  return instance;
};

const axiosServices = createAxiosInstance();

export default axiosServices;
